export const tips = [
    "Brewing up some warm soup",
    "Pro tip: Don't burn your fingers!",
    "Pro tip: Knives are sharp...",
    "Pro tip: Perfectly cook food for best results",
    "Pro tip: Preheat. Your oven is not shy — it just needs a minute.",
    "Pro tip: Taste EVERYTHING. Salt is a shy ingredient.",
    "Pro tip: If it smells like victory, you're probably close.",
    "Pro tip: Dance while you wait — the food will thank you.",
    "Pro tip: Burnt is just 'extra-char flavor'.",
    "Pro tip: Use a tiny spoon for big decisions.",
    "Waiting for deliciousness to assemble itself.",
    "Adding a pinch of patience.",
    "Stirring the pixels gently.",
    "Herding carrots into orderly rows.",
    "Flipping virtual pancakes — please stand by.",
    "Seasoning with a dash of optimism.",
    "Blowing dust off the cookbook",
    "Listening for the oven timer (it's imaginary).",
    "Counting to three… twice.",
    "Tasting the user experience — very spicy.",
    "Polishing spoons and UI elements.",
    "Chasing runaway breadcrumbs.",
    "Asking the recipe genie for directions.",
    "Warming the stove of progress.",
    "Sharpening metaphorical knives.",
    "Consulting the cookbook of secrets.",
    "Negotiating with stubborn ingredients.",
    "Singing to the soup for faster readiness.",
    "Letting the cookies cool.",
    "Rescuing lost spoons from the soup.",
    "Applying butter to all unresolved issues.",
    "Praying the stew doesn't burn.",
    "Pretending this is a dramatic reveal.",
    "Summoning a helpful sous-chef bot.",
    "Hiding tiny easter eggs in the simmer.",
];
